import React from "react";
import { data } from "../data/data";
import ProjectList from "./projectList"; 
import Header from "../navigation/header";
import Footer from "../navigation/footer";
import { Link } from "react-router-dom";

export default function WebProjects() {
    const webProjects = data.filter(proj => 
        proj.languages.some(lang => ['Javascript', 'HTML', 'CSS', 'Bootstrap', 'JQuery'].includes(lang))
    );
    
    return (
        <>
            <Header />
            <div className="workMain">
                <div className="projects-page">
                    <div className="projects-header">
                        <Link to="/work" className="back-link">
                            <span className="back-arrow">←</span> Back to Work
                        </Link>
                        <h1 className="centered-title">Web Development Projects</h1>
                        <p className="projects-summary">
                            A collection of my frontend and full-stack web development projects showcasing 
                            responsive design, interactive features, and modern web technologies.
                        </p>
                    </div>
                    <ProjectList projects={webProjects} />
                </div>
            </div>
            <Footer />
        </>
    );
}